import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import useEmbedRecommendations from "../embed_recommendations/useEmbedRecommendations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NewEmbedRecommendation = (props) => {
  const [, builder] = useContext(VariantContextData);
  const { EmbedRecommendations } = useEmbedRecommendations();

  const onClick = (e) => {
    if (builder.displayFeatureGate(e, "Conditional Embed Recommendations")) {
      EmbedRecommendations.create(
        props.element,
        {},
        {
          callback: (embed_recommendation) => {
            dispatchCustomEvent("focusItem", {
              parent_id: props.element.id,
              item_type: "embed_recommendations",
              item_id: embed_recommendation.id,
            });
          },
        }
      );
    }
  };

  return (
    <React.Fragment>
      <div className="col-xs-12 mb-5">
        <button
          onClick={onClick}
          className="new-embed-recommendation w-full p-2 text-left bg-transparent border-none text-xl text-blue-600 dark:text-blue-200 dark:hover:text-white"
          title="Add Conditional Embed"
        >
          <FontAwesomeIcon icon="plus-square" className="mr-2 text-2xl" /> Add
          Conditional Embed
        </button>
      </div>
    </React.Fragment>
  );
};

export default NewEmbedRecommendation;
